import { BreadCrumbs } from '@/shared/ui/Breadcrumbs/Breadcrumbs'
import { WebinarsView } from '@/widgets/Settings/WebinarsView'

export const WebinarsPage = () => {
  return (
    <>
      <BreadCrumbs />
      <WebinarsView />
    </>
  )
}
